import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facilityuser"

const serviceName = "FacilityUserAssignment-Service: ";

const sortTableFields = ["address_city", "address_street"];
const sortDatabaseFields = ["address.city","address.street"];

const sortRoleTableFields = ["roleName", "userName"];
const sortRoleDataBaseFields = ["role.name", "users.name"];

export default class FacilityUserAssignmentService {

  static async readFacilityUserAssignmentsForBuildingPaginated(buildingID, page, size, search, sort, sortAsc, successF, errorF) {
    return this.readFacilityUserAssignmentsPaginated("building", buildingID, page, size, search, sort, sortAsc, successF, errorF, "buildingId", sortTableFields, sortDatabaseFields);
  }
  
  static async readFacilityUserAssignmentsPaginated(source, id, page, size, search, sort, sortAsc, successF, errorF, paramName, tableFields, databaseFields) {
    let params = createPageableParams(page,size,search,sort,sortAsc,tableFields,databaseFields)
    params.append(paramName, id);    
    await WrapperService.get(API_URL + "/" + source + "/page" , {params : params}, serviceName, successF, errorF);
  }

  static async readFacilityUserAssignmentsForFacilityPaginated(facilityID, page, size, search, sort, sortAsc, successF, errorF) {
    return this.readFacilityUserAssignmentsPaginated("facility", facilityID, page, size, search, sort, sortAsc, successF, errorF, "facilityId", sortRoleTableFields, sortRoleDataBaseFields);
  }

  static async readFacilityUserAssignmentsForFacility(facilityId, successF, errorF) {
    return this.readFacilityUserAssignments("facility", facilityId, successF, errorF);
  }

  static async readFacilityUserAssignmentsForBuilding(buildingId, successF, errorF) {
    return this.readFacilityUserAssignments("building", buildingId, successF, errorF);
  }

  static async readFacilityUserAssignments(source, id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + source + "/" + id, null, serviceName, successF, errorF);
  }

  static postToAPI(assignment, successF, errorF) {
    WrapperService.postWithErrorCause(API_URL, assignment, serviceName, successF, errorF);
  }

  static deleteFromAPI(id, successF, errorF) {
    WrapperService.delete(API_URL + '/' + id, serviceName, successF, errorF);
  }

  static acceptRoleInvitation(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/accept", null, serviceName, successF, errorF);
  }

  static rejectRoleInvitation(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/reject", null, serviceName, successF, errorF);
  }

  static async readFacilityUserAssignmentScoreForFacility(facilityId, successF, errorF) {
    await WrapperService.get(API_URL + "/facility/" + facilityId + "/score", null, serviceName, successF, errorF);
  }
}
